module.exports = __webpack_public_path__ + "img/img@2x.4af5c08f.png";